import { Validateable } from "./interfaces/validateable";

export class TellAFriend extends Validateable {
	public email: string = "";
	public note: string = "";

	public get _email(): string {
		return this.email;
	}

	public set _email(s: string) {
		this.email = s;
	}

	public get _note(): string {
		return this.note;
	}

	public set _note(s: string) {
		this.note = s;
	}

	public getEmail(): string {
		return this.email;
	}
}
